const axios = require('axios');
export default {
  methods: {
    setFontSize (fontSize) {
      parent.postMessage(
        {
          type: "print-order",
          other: { f: "setFontSize", p: fontSize },
        },
        "*"
      );
    },
    postMessageToParent(order) {
      parent.postMessage(
        {
          type: "print-order",
          other: { f: "printOriginalText", p: [order.print] },
          },
          "*"
        );
      if (order.print_qr) {
        parent.postMessage(
          {
            type: "print-order",
            other: { f: "printQRCode", p: [order.print_qr] },
          },
          "*"
          );
        }
    },
    apiRequest (url = '/hello', method = 'GET', data = [], callback) {
      const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        timeout: 90000 // 15 minutes
      })
      switch (method) {
        case 'GET':
          instance.get(url, {params: data})
            .then(
              (response) => {
                callback(response.data)
              }
              ,
              (error) => {
                let response = {'status': false, 'error': error}
                callback(response)
              }
            )
            .catch((error) => {
              let response = {'status': false, 'error': error}
              callback(response)
            })
          break
        case 'POST':
          instance.post(url, data)
            .then(
              (response) => {
                callback(response.data)
              }
            )
          break
        case 'PUT':
          instance.put(url, data)
            .then(
              (response) => {
                callback(response.data)
              }
            )
          break
        case 'DELETE':
          instance.delete(url, {params: data})
          // instance.delete(url, data)
            .then(
              (response) => {
                callback(response.data)
              }
            )
          break
      }
    }
  }
};
